import Cookies from "js-cookie";
import { getLanguage } from "../lang/index";
import { SET_LANGUAGE } from "./mutation-types";

export default {
  getters: {
    getLanguage() {
      return getLanguage();
    }
  },
  mutations: {
    [SET_LANGUAGE](state, language) {
      state.language = language;
      Cookies.set("language", language);
    }
  },
  actions: {
    setLanguage({ commit }, language) {
      commit("SET_LANGUAGE", language);
    }
  }
};
